import React from 'react';

const TermsOfUseIcon = () => {
  return (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="30" height="30" viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="black" stroke-width="200">
            <path d="M980 4894 c-109 -29 -189 -98 -239 -203 l-26 -56 0 -2075 0 -2075 33
            -67 c40 -81 110 -148 190 -180 l57 -23 1525 -3 c1085 -2 1544 0 1590 8 120 21
            215 94 268 208 l27 57 0 2075 0 2075 -26 56 c-51 107 -138 180 -248 205 -88
            21 -3073 19 -3151 -2z m3168 -153 c43 -22 72 -52 98 -101 18 -34 19 -103 19
            -2080 l0 -2045 -22 -40 c-24 -46 -55 -76 -100 -99 -29 -15 -174 -16 -1583 -16
            -1409 0 -1554 1 -1583 16 -45 23 -76 53 -100 99 l-22 40 0 2045 0 2045 22 40
            c24 45 54 75 98 98 27 15 187 16 1583 17 1507 0 1554 -1 1590 -19z"/>
            <path d="M2335 4461 c-50 -23 -93 -65 -113 -111 -8 -19 -17 -76 -20 -126 l-5
            -91 -47 -20 -48 -20 -54 54 c-29 29 -72 63 -95 74 -52 25 -138 27 -186 4 -18
            -8 -95 -77 -169 -153 -114 -115 -138 -144 -148 -182 -23 -86 1 -153 90 -245
            l58 -60 -24 -52 -24 -53 -90 0 c-101 0 -140 -12 -184 -56 -58 -58 -66 -91 -66
            -290 0 -233 14 -276 107 -331 38 -22 60 -27 143 -31 l98 -5 16 -41 c9 -23 16
            -46 16 -52 0 -5 -21 -30 -46 -54 -72 -70 -99 -124 -99 -195 0 -82 27 -124 167
            -261 133 -131 161 -148 243 -149 71 0 124 27 195 99 24 25 49 46 54 46 6 0 29
            -8 52 -17 l41 -17 5 -93 c6 -113 33 -173 97 -218 l43 -30 218 0 218 0 43 30
            c64 45 91 105 97 218 l5 93 41 17 c23 9 46 17 51 17 6 0 33 -23 60 -51 70 -71
            116 -93 191 -93 83 1 123 26 260 166 131 133 148 161 149 243 0 71 -27 124
            -99 195 -25 24 -46 49 -46 54 0 6 7 29 16 52 l16 41 99 5 c127 6 179 34 222
            117 27 54 27 57 27 240 0 205 -8 236 -66 295 -44 44 -83 56 -184 56 l-90 0
            -24 53 -24 52 58 60 c89 92 113 159 90 245 -10 38 -34 67 -148 182 -74 76
            -151 145 -169 153 -48 23 -134 21 -186 -4 -23 -11 -66 -45 -95 -74 l-54 -54
            -49 20 -49 21 0 65 c-1 137 -37 213 -123 256 -49 24 -58 25 -236 25 -159 0
            -192 -3 -226 -19z m409 -142 c25 -20 26 -23 26 -132 0 -131 9 -155 65 -176 22
            -7 74 -29 116 -47 42 -19 82 -34 89 -34 6 0 51 38 100 85 123 119 122 119 271
            -32 64 -65 119 -126 123 -136 9 -27 -9 -54 -91 -138 -53 -54 -75 -84 -75 -100
            1 -13 21 -73 46 -134 31 -76 52 -114 68 -122 14 -8 65 -13 135 -13 109 0 112
            -1 132 -26 19 -25 21 -40 21 -188 0 -210 3 -206 -144 -206 -147 0 -159 -6
            -192 -93 -15 -40 -38 -94 -50 -121 -12 -27 -20 -56 -17 -65 3 -9 38 -50 78
            -91 83 -85 99 -111 89 -143 -8 -28 -199 -224 -237 -243 -16 -9 -38 -12 -50 -8
            -12 3 -59 42 -103 86 -96 95 -91 94 -250 28 -75 -31 -105 -48 -113 -66 -6 -14
            -11 -74 -11 -134 0 -155 7 -150 -210 -150 -217 0 -210 -5 -210 150 0 60 -5
            120 -11 134 -8 18 -38 35 -113 66 -158 66 -154 66 -245 -23 -86 -84 -112 -101
            -144 -91 -28 8 -224 199 -243 237 -22 41 -11 62 76 152 42 44 80 87 83 96 3 9
            -5 38 -17 65 -12 27 -35 81 -50 121 -33 87 -45 93 -192 93 -148 0 -144 -5
            -144 204 0 150 2 165 21 190 20 25 23 26 132 26 70 0 121 5 135 13 25 13 111
            211 112 257 0 19 -20 45 -71 95 -78 77 -102 114 -93 142 4 10 59 71 123 136
            149 151 148 151 271 32 49 -47 94 -85 100 -85 7 0 47 15 89 34 42 18 94 40
            116 47 56 21 65 45 65 176 0 109 1 112 26 132 24 19 40 21 184 21 144 0 160
            -2 184 -21z"/>
            <path d="M2498 3550 c-62 -11 -161 -64 -200 -109 -17 -19 -44 -64 -61 -99 -25
            -54 -30 -76 -30 -142 0 -134 67 -247 183 -309 259 -138 559 71 519 363 -9 67
            -60 166 -108 208 -78 69 -202 105 -303 88z m176 -170 c20 -14 49 -43 64 -64
            24 -34 27 -49 27 -115 0 -66 -3 -81 -27 -116 -15 -22 -44 -51 -65 -65 -31 -21
            -48 -25 -113 -25 -65 0 -82 4 -113 25 -81 55 -118 161 -88 253 14 41 72 104
            115 123 50 23 155 14 200 -16z"/>
            <path d="M1167 1690 c-34 -27 -37 -78 -6 -106 20 -18 41 -19 371 -19 l350 0
            19 24 c24 30 24 62 0 92 l-19 24 -344 3 c-337 3 -345 2 -371 -18z"/>
            <path d="M3240 1697 c-59 -30 -47 -112 18 -129 18 -5 179 -7 358 -6 l326 3 19
            24 c27 34 24 75 -7 100 -26 20 -38 21 -358 21 -246 0 -337 -4 -356 -13z"/>
            <path d="M1160 1470 c-29 -29 -26 -74 6 -99 26 -20 38 -21 366 -21 l339 0 24
            25 c30 29 32 68 5 95 -19 19 -33 20 -370 20 -337 0 -351 -1 -370 -20z"/>
            <path d="M3220 1470 c-27 -27 -25 -66 5 -95 l24 -25 339 0 c328 0 340 1 366
            21 32 25 35 70 6 99 -19 19 -33 20 -370 20 -337 0 -351 -1 -370 -20z"/>
            <path d="M1385 1121 c-50 -12 -65 -25 -192 -154 -104 -105 -123 -129 -123
            -155 0 -19 8 -39 22 -52 42 -39 63 -28 193 100 66 66 129 120 138 120 27 0 32
            -29 9 -59 -69 -93 -40 -216 62 -262 98 -44 141 -22 339 178 167 170 177 186
            139 234 -13 15 -30 22 -51 22 -28 0 -52 -19 -191 -158 -112 -112 -163 -156
            -174 -152 -22 9 -19 35 9 82 45 73 30 163 -35 218 -26 22 -92 49 -110 46 -3
            -1 -18 -4 -35 -8z"/>
            <path d="M3435 1118 c-32 -9 -68 -38 -172 -142 -115 -113 -133 -136 -133 -163
            0 -35 38 -73 73 -73 12 0 67 46 143 121 84 83 128 120 140 117 28 -5 28 -31 0
            -73 -66 -97 -6 -239 110 -261 80 -15 97 -4 282 179 150 149 172 175 172 203 0
            39 -30 67 -71 67 -26 0 -53 -23 -189 -158 -112 -112 -163 -156 -174 -152 -22
            9 -20 33 5 68 45 64 45 145 -2 210 -35 49 -117 74 -184 57z"/>
            </g>
            </svg>
  );
};

export default TermsOfUseIcon;
